// Standard American Football position codes
export const TACKLE_POSITIONS = [
  { value: "QB", label: "QB · Quarterback" },
  { value: "RB", label: "RB · Running Back" },
  { value: "WR", label: "WR · Wide Receiver" },
  { value: "TE", label: "TE · Tight End" },
  { value: "OL", label: "OL · Offensive Line" },
  { value: "DL", label: "DL · Defensive Line" },
  { value: "LB", label: "LB · Linebacker" },
  { value: "CB", label: "CB · Cornerback" },
  { value: "S", label: "S · Safety" },
  { value: "K/P", label: "K/P · Kicker / Punter" },
];

export const FLAG_POSITIONS = [
  { value: "QB", label: "QB · Quarterback" },
  { value: "RB", label: "RB · Running Back" },
  { value: "WR", label: "WR · Wide Receiver" },
  { value: "C", label: "C · Center" },
  { value: "BL", label: "BL · Blocker" },
  { value: "Rusher", label: "Rusher · Rusher" },
  { value: "S", label: "S · Safety" },
  { value: "CB", label: "CB · Cornerback" },
  { value: "LB", label: "LB · Linebacker" },
];

// Returns valid options for a player based on which categories they belong to
export const validPositionsFor = (categories) => {
  const cats = categories || [];
  const hasTackle = cats.includes("tackle");
  const hasFlag = cats.includes("flag_masculino") || cats.includes("flag_femenino");
  if (hasTackle && hasFlag) {
    // union, dedupe by value
    const map = new Map();
    [...TACKLE_POSITIONS, ...FLAG_POSITIONS].forEach(p => map.set(p.value, p));
    return Array.from(map.values());
  }
  if (hasTackle) return TACKLE_POSITIONS;
  if (hasFlag) return FLAG_POSITIONS;
  // No categories yet — show all unique
  const map = new Map();
  [...TACKLE_POSITIONS, ...FLAG_POSITIONS].forEach(p => map.set(p.value, p));
  return Array.from(map.values());
};

// Returns valid position options for ONE specific category
export const validPositionsForCategory = (cat) => {
  if (cat === "tackle") return TACKLE_POSITIONS;
  if (cat === "flag_masculino" || cat === "flag_femenino") return FLAG_POSITIONS;
  return [];
};
